<template>
  <div class="index-left-menu">
    <div class="m-menu-list">
      <div class="m-item" v-for="item of value" :style="{ height: iTemHit + 'px' }">
        <div class="m-one-cate">
          <router-link :to="'/categry?form=' + item.TYPE">
            <div class="cate-name">{{  item.NAME  }}</div>
            <span class="icon iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="m-two-catelist" :style="{ height: conThit + 'px' }">
          <div class="mt-item" v-for="(temp, index) of item.List" :index="index" v-if="(index + 1) <= len">
            <router-link :to="'/categry?form=' + item.TYPE + '&node=' + temp.ID">{{  temp.NAME  }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Category",
  props: ["value"],
  data: function () {
    return {
      totHit: 460,
      iTemHit: 0,
      conThit: 0,
      len: 18,
    }
  },
  mounted: function () {
    // this.$nextTick(() => {
    //   this.iTemHit = this.totHit / this.value.length;
    //   this.conThit = this.iTemHit - 50;
    //   if (this.value.length === 3) {
    //     this.len = 9;
    //   } else {
    //     this.len = 18;
    //   }
    // });

    this.iTemHit = this.totHit / 2;
    this.conThit = this.iTemHit - 50;
    if (this.value.length === 3) {
      this.len = 9;
    } else {
      this.len = 18;
    }

  },
  methods: {}
}
</script>

<style lang="css" scoped>
.m-menu-list {
  width: 100%;
}

.m-menu-list .m-item {
  height: 146.66px;
  height: calc(460px / 3);
}

.m-menu-list .m-one-cate {
  height: 30px;
  line-height: 30px;
}

.m-menu-list .m-one-cate a {
  display: block;
  cursor: pointer;
  position: relative;
  font-size: 20px;
  color: #252525;
}

.m-menu-list .m-one-cate a .cate-name {
  position: relative;
  width: 100%;
  height: 100%;
  font-weight: 600;
  padding-right: 39px;
}

.m-menu-list .m-one-cate a .icon {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 24px;
}

.m-two-catelist {
  width: 100%;
  height: 100px;
  border-bottom: 1px solid #eee;
  *zoom: 1;
  padding-top: 7px;
  overflow: hidden;
}

.m-menu-list .m-item:last-child .m-two-catelist {
  border-bottom: none;
}

.m-two-catelist:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.m-two-catelist .mt-item {
  float: left;
  width: 33.333%;
  height: 18px;
  line-height: 18px;
  padding-right: 8px;
  text-align: left;
  margin: 5px 0px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.m-two-catelist .mt-item a {
  font-size: 16px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Category.vue